// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__9V2nN","buttons":"RemoveExpirationActionButtons_buttons__1piQQ"};